var _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _circle, _g7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRobot = function SvgRobot(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "wholerobot",
    viewBox: "0 0 270 170",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133,
    cy: 160,
    rx: 25,
    ry: 3,
    fill: "url('#myGradient')"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cog"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    d: "M148.883 145.788v-1.616l-1.856-.615c-.029-.3-.069-.6-.117-.9l1.632-1.074-.418-1.561-1.948-.114q-.161-.429-.348-.843l1.3-1.457-.808-1.4-1.91.394q-.267-.37-.555-.724l.875-1.743-1.143-1.143-1.739.873q-.354-.291-.727-.559l.393-1.9-1.4-.808-1.446 1.286q-.42-.192-.855-.355l-.113-1.931-1.561-.419-1.061 1.613c-.305-.05-.612-.092-.922-.123l-.607-1.831h-1.617l-.6 1.826q-.47.045-.929.12l-1.056-1.6-1.561.419-.112 1.91c-.3.111-.588.23-.874.36l-1.428-1.27-1.4.808.386 1.869q-.387.278-.753.577l-1.706-.856-1.143 1.143.854 1.7q-.3.367-.581.755l-1.863-.384-.808 1.4 1.26 1.417q-.2.435-.367.886l-1.893.111-.419 1.561 1.585 1.043q-.078.469-.125.95l-1.8.6v1.616l1.8.6q.047.48.125.95l-1.585 1.043.419 1.561 1.893.111q.169.45.367.886l-1.26 1.417.808 1.4 1.863-.384q.279.387.581.755l-.854 1.7 1.143 1.142 1.706-.855q.366.3.753.576l-.386 1.87 1.4.808 1.428-1.27c.286.13.578.249.874.36l.112 1.91 1.561.418 1.056-1.6q.459.073.929.119l.6 1.826h1.617l.607-1.831c.31-.03.617-.072.922-.122l1.061 1.612 1.561-.418.113-1.931q.435-.165.855-.355l1.446 1.286 1.4-.808-.393-1.9q.372-.269.727-.559l1.739.872 1.143-1.142-.875-1.743q.288-.353.555-.724l1.91.394.808-1.4-1.3-1.457c.125-.276.241-.558.348-.843l1.948-.114.418-1.561-1.632-1.098c.048-.3.088-.6.117-.9zm-15.067-12.744a11.975 11.975 0 018.7 5.043l-7.352 4.245a3.59 3.59 0 00-1.348-.78zm-7.139 1.577a11.916 11.916 0 014.98-1.581v8.512a3.6 3.6 0 00-1.349.78l-3.02-1.744-4.37-2.523a12.059 12.059 0 013.759-3.444zm-4.842 15.407a11.982 11.982 0 010-10.095l7.394 4.269a3.567 3.567 0 000 1.557zm9.822 6.893a11.974 11.974 0 01-8.739-5.026l7.39-4.266a3.586 3.586 0 001.349.779zm1.079-10.071a1.87 1.87 0 111.87-1.87 1.869 1.869 0 01-1.87 1.87zm1.08 10.067v-8.509a3.574 3.574 0 001.348-.779l7.352 4.244a11.976 11.976 0 01-8.7 5.044zM143.6 150l-7.351-4.244a3.567 3.567 0 000-1.557l7.351-4.245a11.979 11.979 0 010 10.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    d: "M132.736 132a12.977 12.977 0 1012.977 12.977A12.976 12.976 0 00132.736 132zm-6.059 2.618a11.916 11.916 0 014.98-1.581v8.512a3.6 3.6 0 00-1.349.78l-3.02-1.744-4.37-2.523a12.059 12.059 0 013.759-3.441zm-5.957 10.362a11.93 11.93 0 011.115-5.047l7.394 4.269a3.567 3.567 0 000 1.557l-7.394 4.269a11.935 11.935 0 01-1.115-5.048zm10.937 11.941a11.974 11.974 0 01-8.739-5.026l7.39-4.266a3.586 3.586 0 001.349.779zm-.79-11.941a1.87 1.87 0 111.869 1.87 1.869 1.869 0 01-1.869-1.87zm2.949 11.937v-8.509a3.574 3.574 0 001.348-.779l7.352 4.244a11.976 11.976 0 01-8.7 5.044zM144.7 144.98a11.927 11.927 0 01-1.1 5.02l-7.351-4.244a3.567 3.567 0 000-1.557l7.351-4.245a11.933 11.933 0 011.1 5.026zm-9.535-2.648a3.59 3.59 0 00-1.348-.78v-8.508a11.975 11.975 0 018.7 5.043z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "robot"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "rightArm"
  }, /*#__PURE__*/React.createElement("g", {
    className: "rightForearm"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    d: "M73.361 130a4.182 4.182 0 00.269-2.031 4.144 4.144 0 10-8.224 1.023A1 1 0 0164.3 130.1h0a1.007 1.007 0 01-.876-.865 6.148 6.148 0 1111.823 1.452 1.01 1.01 0 01-1.063.633h0a.989.989 0 01-.823-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M73.177 99.291l-2.929 23.925"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.248,
    cy: 123.216,
    r: 2.112,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M96.202 103.486l-23.025-4.195"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.177,
    cy: 99.291,
    r: 2.112,
    fill: "#ccc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "leftArm"
  }, /*#__PURE__*/React.createElement("g", {
    className: "leftForearm"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    d: "M192.406 131.033a4.18 4.18 0 01-.269-2.031 4.144 4.144 0 018.227-.011 4.064 4.064 0 010 1.034 1 1 0 001.111 1.118h0a1 1 0 00.875-.865 6.148 6.148 0 10-11.823 1.452 1.012 1.012 0 001.064.634h0a.99.99 0 00.815-1.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M192.591 100.329l2.929 23.925"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.52,
    cy: 124.254,
    r: 2.112,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#56555e",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M169.565 104.524l23.026-4.195"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.591,
    cy: 100.329,
    r: 2.112,
    fill: "#ccc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "body"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M136.409 145.323s0 3.78-3.673 3.78-3.672-3.78-3.672-3.78v-19.054h7.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4a7c",
    d: "M139.817 135.366s0 3.725-7.081 3.725-7.08-3.725-7.08-3.725v-11.791h14.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f356d",
    d: "M97.585 115.2s11.506 12.454 36.1 12.138 33.573-12.138 33.573-12.138zM167.759 97.231a6.619 6.619 0 012 .055 2.358 2.358 0 011.261.58 2.562 2.562 0 01.436 1.909 90.507 90.507 0 01-1.3 11.772l-2.045.309a.459.459 0 01-.294-.022c-.139-.079-.153-.268-.151-.428q.078-7 .158-14M97.908 95.97a6.619 6.619 0 00-2 .055 2.362 2.362 0 00-1.261.58 2.562 2.562 0 00-.436 1.909 90.507 90.507 0 001.3 11.772l2.045.308a.446.446 0 00.294-.021c.139-.079.154-.269.152-.428l-.158-14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4a7c",
    d: "M97.585 89.034h70.304v29.95H97.585z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f356d",
    d: "M119.968 86.512h30.581v2.522h-30.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b4a7c",
    d: "M164.105 86.512h-63.684V54.671a31.842 31.842 0 0131.842-31.842 31.842 31.842 0 0131.842 31.842z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "face"
  }, /*#__PURE__*/React.createElement("g", {
    className: "eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.313,
    cy: 56.72,
    r: 12.138,
    fill: "#cef4f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99b3c1",
    d: "M134.313 69.961a13.241 13.241 0 1113.241-13.241 13.255 13.255 0 01-13.241 13.241zm0-24.276a11.035 11.035 0 1011.034 11.035 11.046 11.046 0 00-11.034-11.035z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pupil",
    fill: "#1b4054",
    d: "M132.151 56.72a24.615 24.615 0 00-.041 2.975l.273 3.431a4.833 4.833 0 00.3 1.55 1.639 1.639 0 001.141 1.009 1.609 1.609 0 001.538-.771 3.99 3.99 0 00.528-1.726 16.976 16.976 0 00-.4-6.368 2.777 2.777 0 00-1.006-1.745 1.39 1.39 0 00-1.945.545 3.353 3.353 0 00-.388 1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "smile",
    fill: "#99b3c1",
    d: "M138.29 74.765c.1-.031.279.132.433.5a3.551 3.551 0 01.19 1.692 4.576 4.576 0 01-1.033 2.385 4.834 4.834 0 01-6.021 1.046 4.58 4.58 0 01-1.776-1.9 3.532 3.532 0 01-.392-1.656c.019-.4.13-.615.236-.621.245-.018.414.776 1.141 1.662a4.33 4.33 0 001.5 1.177 3.847 3.847 0 004.193-.729 4.331 4.331 0 001.016-1.614c.386-1.072.277-1.877.513-1.942z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "dial"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.397,
    cy: 104.325,
    r: 6.778,
    fill: "#cef4f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99b3c1",
    d: "M114.766 112.206a7.882 7.882 0 117.882-7.881 7.89 7.89 0 01-7.882 7.881zm0-13.556a5.675 5.675 0 105.675 5.675 5.682 5.682 0 00-5.675-5.675z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dialhand",
    fill: "#1b4054",
    d: "M121.107 106.1c-.1.208-1.463-.274-3.148-.766s-3.086-.835-3.061-1.067 1.529-.245 3.293.28 3.018 1.358 2.916 1.553z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "spring"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 0.543,
    d: "M116.088 15.923a9.419 9.419 0 011.025-5.6c-.006 0 .754-1.212 1.823-.652.074-.073 4.242 1.522 3.863 8.515.1 4.113-4.748-3.182-1.023-9.355a1.282 1.282 0 011.688-.4c.077-.063 4.1 1.994 3.236 8.917-.184 4.107-4.488-3.7-.36-9.433a1.36 1.36 0 011.87-.226c.081-.053 3.931 2.461 2.567 9.254-.482 4.068-4.19-4.209.329-9.435A1.356 1.356 0 01133 7.5c.083-.044 3.733 2.906 1.877 9.512-.777 3.988-3.862-4.682 1.023-9.361a1.309 1.309 0 011.89.212c.086-.035 3.513 3.329 1.176 9.69-1.069 3.888-3.512-5.108 1.7-9.2a1.33 1.33 0 011.873.433c.087-.025 3.267 3.728.466 9.788-1.352 3.745-3.137-5.5 2.375-8.959a1.375 1.375 0 011.842.653 7.9 7.9 0 011.161 5.958"
  })), /*#__PURE__*/React.createElement("path", {
    className: "electricity",
    style: {
      filter: "url(#glow)"
    },
    fill: "none",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 0.543,
    d: "M116.088 15.923a9.419 9.419 0 011.025-5.6c-.006 0 .754-1.212 1.823-.652.074-.073 4.242 1.522 3.863 8.515.1 4.113-4.748-3.182-1.023-9.355a1.282 1.282 0 011.688-.4c.077-.063 4.1 1.994 3.236 8.917-.184 4.107-4.488-3.7-.36-9.433a1.36 1.36 0 011.87-.226c.081-.053 3.931 2.461 2.567 9.254-.482 4.068-4.19-4.209.329-9.435A1.356 1.356 0 01133 7.5c.083-.044 3.733 2.906 1.877 9.512-.777 3.988-3.862-4.682 1.023-9.361a1.309 1.309 0 011.89.212c.086-.035 3.513 3.329 1.176 9.69-1.069 3.888-3.512-5.108 1.7-9.2a1.33 1.33 0 011.873.433c.087-.025 3.267 3.728.466 9.788-1.352 3.745-3.137-5.5 2.375-8.959a1.375 1.375 0 011.842.653 7.9 7.9 0 011.161 5.958"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 1.086,
    d: "M119.485 26.927l-2.551-9.984"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.673,
    cy: 15.923,
    r: 1.997,
    fill: "#f2f0f0"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#56555e",
    strokeMiterlimit: 10,
    strokeWidth: 1.086,
    d: "M145.042 26.927l2.551-9.984"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.854,
    cy: 15.923,
    r: 1.997,
    fill: "#f2f0f0"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/robot.10ce4d19.svg";
export { ForwardRef as ReactComponent };